import { gql } from '@apollo/client';
import { CORE_SAVED_SEARCH_FIELDS } from '@general/graphql/fragments/saved-searches';

export const SAVED_CONTACTS_QUERY = gql`
    query getSavedContacts {
        contacts {
            id
            recordId
            firstName
            lastName
            suffix
            title
            photoUrl
            status
            company {
                recordId
                name
            }
            address {
                purpose
                city
                stateProvince
                country
            }
            events {
                recordId
                code
            }
        }
    }
`;

export const SAVED_CONTACTS_RECORD_ID_QUERY = gql`
    query getSavedContactRecordIds {
        contacts {
            id
            recordId
        }
    }
`;

export const SAVE_CONTACT = gql`
    mutation SaveContact($recordId: Int!) {
        saveContact(recordId: $recordId) {
            contact {
                recordId
                firstName
                lastName
                suffix
                title
                photoUrl
                company {
                    recordId
                    name
                }
                address {
                    purpose
                    city
                    stateProvince
                    country
                }
            }
        }
    }
`;

export const REMOVE_CONTACT = gql`
    mutation RemoveContact($recordId: Int!) {
        removeContact(recordId: $recordId) {
            contact {
                recordId
            }
        }
    }
`;

export const GET_CONTACTS_WITH_SAVED_SEARCHES = gql`
    query getSavedContacts {
        ${CORE_SAVED_SEARCH_FIELDS}
        contacts {
            id
            recordId
            firstName
            lastName
            suffix
            title
            photoUrl
            status
            address {
                purpose
                city
                stateProvince
                country
            }
            company {
                recordId
                name
                primaryBusinessType {
                    name
                }
            }
            savedSearches {
                ...CoreSavedSearchFields
            }
        }
    }
`;
